// extracted by mini-css-extract-plugin
module.exports = {"wizardContainer":"ScanWizard_wizardContainer__2IX4w","wizard":"ScanWizard_wizard__2FZ_h","clickable":"ScanWizard_clickable__3xLgq"};